<script lang="ts">
	import error from '$lib/assets/error.svg';
	import warning from '$lib/assets/paymentRequired.svg';
	import { GLOBAL_ERROR } from '../../../constants';
	import { ErrorCodes } from '../../../types/types';

	const labels = {
		[ErrorCodes.InternalServer]: {
			title: 'An error happened',
			message:
				'We are having difficulties processing some information, so you may need to try to make the action again.',
			buttonText: 'OK',
			type: 'error'
		},
		[ErrorCodes.WrongSignUpBrowser]: {
			title: 'Wrong browser',
			message: 'Please use the same browser that you signed up with.',
			buttonText: 'OK',
			type: 'error'
		},
		[ErrorCodes.VerificationCodeNotValid]: {
			title: 'Invalid Link',
			message: 'The verification link is not valid. Please request a new link and try again.',
			buttonText: 'OK',
			type: 'error'
		},
		[ErrorCodes.ReviewAlreadyHidden]: {
			title: 'Review already hidden',
			message: "This review has already been hidden and can't be hidden again.",
			buttonText: 'OK',
			type: 'error'
		}
	};

	let errorCode: ErrorCodes | null = null;
	let title: string | null;
	let message: string | null;
	let handleError = () => (errorCode = null);
	let removeButton = false;
	let buttonText: string | null;
	let type: 'error' | 'warning';

	document.addEventListener(GLOBAL_ERROR, (e: any) => {
		errorCode = e.detail.code as ErrorCodes;
	});

	function clickOutside(element: HTMLElement, callbackFunction: Function) {
		function onClick(event: MouseEvent) {
			const targetNode = event.target as Node;
			if (targetNode && !element.contains(targetNode)) {
				callbackFunction();
			}
		}

		document.body.addEventListener('click', onClick);

		return {
			update(newCallbackFunction: Function) {
				callbackFunction = newCallbackFunction;
			},
			destroy() {
				document.body.removeEventListener('click', onClick);
			}
		};
	}
</script>

{#if !!errorCode}
	<div class="fixed top-0 left-0 w-full h-full z-[10001] bg-black bg-opacity-20">
		<div
			use:clickOutside={() => handleError()}
			class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#FFF] w-[90%] sm:w-[518px] p-8 flex gap-6 flex-col items-center justify-center rounded-xl"
		>
			<img src={(labels[errorCode].type === 'error' ? error : warning) || type} alt="error" />
			<div class="flex flex-col gap-6 items-center text-center">
				<p class="text-2xl">{labels[errorCode].title ?? title}</p>
				<p class="text-xl">
					{labels[errorCode].message ?? message}
				</p>
			</div>
			{#if !removeButton}
				<button
					style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);"
					class="bg-[#F79120] text-[#FFF] min-w-[165px] h-[56px] rounded-md text-xl px-4"
					on:click={handleError}
				>
					{labels[errorCode].buttonText ?? buttonText}
				</button>
			{/if}
		</div>
	</div>
{/if}
